<template>
	<div>SKU组合demo</div>
	<!-- <div v-for="(v, i) in list" :key="i" class="mt-20">
		<b>{{ v.name }}：</b>
		<el-checkbox-group v-model="checkList[i].list">
			<el-checkbox v-for="(k, j) in v.list" :key="j" :label="k" />
		</el-checkbox-group>
	</div> -->
	<div class="mt-20">
		<el-button type="primary" @click="handleClick1">确定</el-button>
	</div>
	<div class="mt-20">
		<el-tag v-for="(item, index) in skuList" :key="index" style="margin:10px 10px;">{{ item }}</el-tag>
	</div>
	<el-divider>我是分割线</el-divider>

	<div class="block">
		<span class="demonstration">默认 click 触发子菜单</span>
		<el-cascader ref="cascader" :options="options" placeholder="请为商品选择分类" :props="props" @change="handleChange" clearable
		 filterable></el-cascader>
	</div>
	<el-divider>我是分割线</el-divider>
	<!-- <div class="col">
		<el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="用户管理" name="first">用户管理</el-tab-pane>
			<el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
			<el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
			<el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane>
		</el-tabs>
	</div> -->
	<el-divider>我是分割线</el-divider>
	<!-- <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}">
		<el-table-column prop="date" label="日期" sortable width="180">
		</el-table-column>
		<el-table-column prop="name" label="姓名" sortable width="180">
		</el-table-column>
		<el-table-column prop="address" label="地址" :formatter="formatter">
		</el-table-column>
	</el-table> -->
	<el-divider>我是分割线</el-divider>
	<el-select v-model="valueselect" filterable clearable placeholder="请选择">
		<el-option v-for="item in optionselect" :key="item.value" :label="item.label" :value="item.value">
		</el-option>
	</el-select>
	<!-- <el-collapse v-model="activeNames" @change="handleChange">
		<el-collapse-item title="一致性 Consistency" name="first">
			<div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div>
		</el-collapse-item>
		<el-collapse-item title="反馈 Feedback" name="second">
			<div>控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；</div>
		</el-collapse-item>
		<el-collapse-item title="效率 Efficiency" name="third">
			<div>简化流程：设计简洁直观的操作流程；</div>
		</el-collapse-item>
		<el-collapse-item title="可控 Controllability" name="fourth">
			<div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
		</el-collapse-item>
	</el-collapse> -->
	<el-divider>我是分割线</el-divider>
	<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
	<div style="margin: 15px 0;"></div>
	<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
		<el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
	</el-checkbox-group>

	<el-divider>我是分割线211</el-divider>
	<!-- 大文件上传 -->
	<upload-plus buttonTitle='上传视频' upload_path='upload_product_video' @success-plus='bigFile' :auto_close="true"></upload-plus>
	<el-divider>我是分割线</el-divider>
	<el-tooltip class="item" effect="dark" content="请选择对应邮件模板" placement="top-start">
		<el-button type="success" @click="email_template = true" icon="el-icon-message" circle></el-button>
	</el-tooltip>
	<el-drawer title="邮件模板类型" v-model="email_template" direction="rtl" size="50%">
		<el-table :data="emailData" border highlight-current-row v-loading="loading_email">
			<el-table-column type="expand">
				<template #default="scope">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item>
							<!-- <i slot="label" class="el-icon-copy-document" @click='copy_email(scope.row.email_content)'>&nbsp;&nbsp;&nbsp;邮件模板</i> -->
							<div v-html="scope.row.email_content"></div>
							<!-- <div :style="email_width?'width: '+email_width+';':''" v-html="scope.row.email_content"></div> -->
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column prop="id" label="ID" align="center">
			</el-table-column>
			<el-table-column prop="name" label="邮件模板" align="center"></el-table-column>
		</el-table>
	</el-drawer>
</template>

<script>
	const cityOptions = ['上海', '北京', '广州', '深圳'];
	import UploadPlus from '../common/UploadPlus.vue'
	import VueClipboard from 'vue-clipboard2'
	export default {
		name: 'Test',
		components: {
			UploadPlus,
			VueClipboard
		},
		data() {
			return {
				email_width: '800px',
				email_template: false,
				loading_email: true,
				activeName: 'second',
				activeNames: ['first', 'second', 'third'],
				checkAll: false,
				checkedCities: ['上海', '北京'],
				cities: cityOptions,
				isIndeterminate: true,
				props: {
					value: 'id',
					label: 'name',
					children: 'son'
				},
				options: [],
				optionselect: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				valueselect: '',
				tableData: [{
					date: '2016-05-02',
					name: '王小',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-04',
					name: '李小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				}, {
					date: '2016-05-01',
					name: '张小虎',
					address: '上海市普陀区金沙江路 1519 弄'
				}, {
					date: '2016-05-03',
					name: '杨小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}],
				list: [{
						name: '尺码',
						list: ['S', 'M', 'L', 'XL', 'XXL']
					},
					{
						name: '颜色',
						list: ['红色', '黄色', '蓝色', '粉色', '紫色']
					},
					{
						name: '图案',
						list: ['猫咪', '人物', '飞机', '闪电', '字母']
					}
				],
				checkList: [{
						name: '尺码',
						list: []
					},
					{
						name: '颜色',
						list: []
					},
					{
						name: '图案',
						list: []
					}
				],
				skuArray: [],
				skuList: []
			}
		},
		methods: {
			copy_email(data) {
				this.$copyText(data).then((re) => {
					console.log(re)
					this.alertSuccess('复制成功')
				}).catch((err) => {
					console.log(err)
					this.alertError('复制成功')
				})
			},
			bigFile(file) {
				console.log(file) //upload_product_video/20211117/6194639ace1c7.wmv
			},
			handleClick1() {
				// 先清空数据，保证连续点击按钮，数据不会重复
				this.skuArray = []
				this.skuList = []
				console.log(this.checkList)
				// 将选中的规格组合成一个大数组 [[1, 2], [a, b]...]
				this.checkList.forEach(element => {
					element.list.length > 0 ? this.skuArray.push(element.list) : ''
				})
				// 勾选了规格，才调用方法
				if (this.skuArray.length > 0) {
					this.getSkuData([], 0, this.skuArray)
				} else {
					this.$message.error('请先勾选规格')
				}
				console.log(this.skuArray)

			},
			// 递归获取每条SKU数据
			getSkuData(skuArr = [], i, list) {
				for (let j = 0; j < list[i].length; j++) {
					if (i < list.length - 1) {
						skuArr[i] = list[i][j]
						this.getSkuData(skuArr, i + 1, list) // 递归循环
					} else {
						this.skuList.push([...skuArr, list[i][j]]) // 扩展运算符，连接两个数组
					}
				}
			},
			handleCheckAllChange(val) {
				this.checkedCities = val ? cityOptions : [];
				this.isIndeterminate = false;
			},
			handleCheckedCitiesChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.cities.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
			},
			formatter(row, column) {
				// console.log(row,col)
				return row.address;
			},
			handleChange(value) {
				console.log(value);
			},
			getData() {
				this.httpPost({
					url: '/admin/category/categoryList',

				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data)
					this.options = temp

				}).catch((err) => {


				})
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			getEmailTemplate(){
				this.httpPost({
					url: '/admin/order_email_template/order_email_template_list'
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.emailData = temp
					this.loading_email = false
							
				}).catch((err) => {})
			},
		},
		created() {
			this.getData();
			// this.getEmailTemplate();
		}
	};
</script>

<style>
	.mt-20 {
		margin-top: 20px;
	}

	.el-icon-copy-document {
		cursor: pointer;
	}
	body #app, html #app{
		overflow: scroll;
	}
	.el-drawer.ltr, .el-drawer.rtl{
		overflow-y: scroll;
	}
</style>
